import { render, staticRenderFns } from "./component-moments.vue?vue&type=template&id=5f29a14c&scoped=true&"
import script from "./component-moments.vue?vue&type=script&lang=js&"
export * from "./component-moments.vue?vue&type=script&lang=js&"
import style0 from "./component-moments.vue?vue&type=style&index=0&id=5f29a14c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f29a14c",
  null
  
)

export default component.exports